/**
 * contexts/AuthContext.ts
 * Authentication context definition
 *
 * Provides global authentication state and operations to all components.
 * Follows the same pattern as ThemeContext for consistency.
 */

import { createContext } from 'react';
import type { UseAuthReturn } from '@/types/auth';

/**
 * Authentication context - provides auth state and operations to components
 *
 * NOTE:
 * This context is populated by AuthProvider (src/providers/AuthProvider.tsx).
 *
 */
export const AuthContext = createContext<UseAuthReturn | null>(null);
